export enum DealStage {
  Application = 'application',
  Underwriting = 'underwriting',
  Closing = 'closing',
  Funded = 'funded',
  Inactive = 'inactive',
}
